import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toArray',
    standalone: false
})
export class ObjectToArrayPipe implements PipeTransform {
    transform(obj?: object): any[] {
        if (!obj || typeof obj !== 'object') { return; }
        return obj && Object.keys(obj).map(key => obj[key]);
    }
}
